import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, Plus, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export default function DestinationsList() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  const load = (query = "") => api.get("/admin/destinations", { params: query ? { q: query } : {} }).then(r => setItems(r.data || []));
  useEffect(() => { load(); }, []);

  return (
    <div data-testid="admin-destinations-list">
      <div className="flex items-start justify-between gap-6">
        <div>
          <p className="eyebrow">Content</p>
          <h1 className="mt-3 font-serif text-4xl text-jade font-light">Destinations</h1>
          <p className="mt-3 text-ink/65 text-[14px] font-light max-w-xl">
            18 destinations published initially. Add new ones, reorder, or unpublish.
          </p>
        </div>
        <Link to="/studio/destinations/new" data-testid="admin-destinations-new" className="btn-primary inline-flex items-center gap-2">
          <Plus size={14} /> New destination
        </Link>
      </div>

      <div className="mt-10 flex items-center gap-2 border-b border-mist pb-2">
        <Search size={14} className="text-ink/50" />
        <input
          data-testid="destinations-search"
          type="text"
          placeholder="Search by name, slug, region, tagline…"
          value={q}
          onChange={(e) => { setQ(e.target.value); load(e.target.value); }}
          className="flex-1 bg-transparent outline-none text-[14px]"
        />
      </div>

      <div className="mt-8 space-y-2">
        {items.map((d) => (
          <Link
            key={d.slug}
            to={`/studio/destinations/${d.slug}`}
            data-testid={`admin-destination-${d.slug}`}
            className="flex items-center justify-between border border-mist px-5 py-4 hover:border-jade transition-colors group"
          >
            <div className="flex items-center gap-5">
              <span className="text-[11px] tracking-[0.14em] uppercase text-ink/45 w-10">#{d.order ?? 0}</span>
              <div>
                <p className="font-serif text-lg text-jade">{d.name}</p>
                <p className="text-[12px] text-ink/55">{d.region} · /destinations/{d.slug}</p>
              </div>
            </div>
            <div className="flex items-center gap-5">
              <span
                data-testid={`destination-status-${d.slug}`}
                className={`text-[10px] tracking-[0.18em] uppercase px-3 py-1 ${
                  d.status === "published" ? "bg-jade/10 text-jade" : "bg-copper/10 text-copper"
                }`}
              >
                {d.status || "draft"}
              </span>
              <ArrowRight size={16} className="text-ink/40 group-hover:text-copper transition-colors" />
            </div>
          </Link>
        ))}
        {items.length === 0 && <p className="text-ink/55 text-sm italic">No destinations found.</p>}
      </div>
    </div>
  );
}
